import React from 'react';

import { createClassName } from 'utils/createClassName';

import './singleCharInputControlStyles.scss';

type Props = {
  value: string;
  name?: string;
  invalid?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  onValueChange(nextValue: string): void;
  onBackspace(): void;
};

export const SingleCharInputControlComponent = (props: Props) => {
  const {
    value,
    name,
    onValueChange,
    onBackspace,
    autoFocus,
    invalid,
    disabled,
    readOnly,
  } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value: nextValue } = event.currentTarget;

      onValueChange(nextValue);
    },
    [onValueChange]
  );

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Backspace') {
        onBackspace();
      }
    },
    [onBackspace]
  );

  const className = createClassName('singleCharInputControl')({
    invalid,
    readOnly,
  });

  React.useLayoutEffect(() => {
    const { current: inputElement } = inputRef;

    if (autoFocus && inputElement) {
      inputElement.focus();
    }
  }, [autoFocus]);

  return (
    <input
      ref={inputRef}
      type="text"
      name={name}
      disabled={disabled}
      className={className}
      readOnly={readOnly}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      data-invalid={invalid}
    />
  );
};
